var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, width: "430", persistent: "" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v(" Confirm Mass Copy ")]),
          _c(
            "v-card-text",
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 px-0 pb-0 d-inline-flex",
                  attrs: { cols: "auto" },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-4", attrs: { color: "warning" } },
                    [_vm._v("mdi-alert")]
                  ),
                  _vm._v(
                    " Existing features will be moved to Page 7 of their respective ads. Proceed? "
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  class: _vm.body,
                  attrs: { color: "grey darken-1", text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  class: _vm.body,
                  attrs: { color: "warning" },
                  on: { click: _vm.confirm },
                },
                [_vm._v(" Continue ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }